import { ReactNode } from 'react';
import { useParams } from 'react-router-dom';

import { ReadRetailerNetwork } from '@occc-app/App/PolicyBasedAccessControl/userActions';

import { RetailerNetworkGuard } from '../guards/retailer-network.guard';

type RetailerNetworkPerformancePageGuardProps = {
  children: ReactNode;
};

export const RetailerNetworkPerformancePageGuard = ({
  children,
}: RetailerNetworkPerformancePageGuardProps) => {
  const { networkId = '' } = useParams<{ networkId: string }>();

  return (
    <RetailerNetworkGuard policyWithParams={ReadRetailerNetwork({ uuid: networkId })}>
      {children}
    </RetailerNetworkGuard>
  );
};
